import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import Input from '../../../../../components/input/input';

import './styles.scss';
import classNames from 'classnames';

type SearchInputProps = {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  className?: string;
  placeholder?: string;
};

export const SearchInput: React.FC<SearchInputProps> = ({
  searchTerm,
  setSearchTerm,
  className,
  placeholder = 'Search',
}) => {
  return (
    <Input
      icon={<FontAwesomeIcon icon={faSearch} />}
      placeholder={placeholder}
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      className={classNames('search-input', className)}
    />
  );
};
